import { useState, useCallback } from "react";
import { formatPhone, normalizePhone, isValidPhone, PHONE_ERROR } from "@/lib/phone";

/**
 * useFormattedPhone — keeps a phone field in "1 (555) 555-5555" form while
 * also exposing the normalized E.164 value for submission.
 *
 * Usage:
 *   const phone = useFormattedPhone();
 *   <input value={phone.display} onChange={phone.onChange} />
 *   const normalized = phone.normalized;   // "+15555555555"
 *   const ok = phone.isValid;              // boolean
 */
export function useFormattedPhone(initial = "") {
  const [display, setDisplay] = useState(formatPhone(initial));

  const onChange = useCallback((e) => {
    const next = typeof e === "string" ? e : e?.target?.value ?? "";
    setDisplay(formatPhone(next));
  }, []);

  const reset = useCallback(() => setDisplay(""), []);

  return {
    display,
    onChange,
    reset,
    setDisplay,
    normalized: normalizePhone(display),
    isValid: isValidPhone(display),
    hasValue: display.trim().length > 0,
    error: PHONE_ERROR,
  };
}
